import type { PanelEntry } from "./types";

// Source: psyna-cpo product/research/admin-console.md, section V.3 (names and descriptions verbatim).
export const PANELS = [
  {
    id: "revenue",
    screen: "money",
    name: "Revenue",
    description:
      "Только завершённые платежи (COMPLETED), без возвратов и sandbox; Stars по курсу плюс USD.",
  },
  {
    id: "ai_cost_from_credit_log",
    screen: "money",
    name: "AI cost (from credit log)",
    description:
      "Берётся из кредитного журнала; другая цифра, чем в панели «по типу разбора» (другая таблица).",
  },
  {
    id: "margin",
    screen: "money",
    name: "Margin",
    description: "Показана рядом с выручкой и стоимостью; формула в А не описана [не знаю].",
  },
  {
    id: "users_without_payment",
    screen: "money",
    name: "Users without payment",
    description:
      "Считает не то, что обещает название: все пользователи до конца периода минус платившие в периоде (не «бесплатные периода»).",
  },
  {
    id: "paying_users",
    screen: "money",
    name: "Paying users",
    description: "Платившие в периоде.",
  },
  {
    id: "payment_conversion",
    screen: "money",
    name: "Payment conversion",
    description:
      "Считает не то: платившие периода делятся на всех пользователей за всё время, а не на пришедших в периоде.",
  },
  {
    id: "break_even",
    screen: "money",
    name: "Break-even",
    description: "Показатель без подсказки; как считается, в А не описано.",
  },
  {
    id: "revenue_per_user_arpu",
    screen: "money",
    name: "Revenue per user (ARPU)",
    description: "Средняя выручка на пользователя; формула в А не расписана.",
  },
  {
    id: "ai_cost_per_free_user",
    screen: "money",
    name: "AI cost per free user",
    description: "Стоимость на бесплатного пользователя; опирается на «Бесплатные» (см. выше).",
  },
  {
    id: "revenue_cost_and_margin_by_day",
    screen: "money",
    name: "Revenue, cost and margin by day",
    description: "График по дням; автообновление 60 с.",
  },
  {
    id: "by_product_sku",
    screen: "money",
    name: "By product (SKU)",
    description: "Стоимость делится на число покупок, а не берётся фактом.",
  },
  {
    id: "ai_cost_by_reading_type",
    screen: "money",
    name: "AI cost by reading type",
    description: "Берётся из другой таблицы, чем KPI «Стоимость LLM», и даёт другую сумму.",
  },
  {
    id: "composite_chart_funnel",
    screen: "money",
    name: "Composite chart funnel",
    description: "Воронка по композитной карте; подробностей в А нет.",
  },
  {
    id: "cohorts_8_weeks",
    screen: "money",
    name: "Cohorts (8 weeks)",
    description: "Когорты за 8 недель, колонки День 0/7/14/30.",
  },
  {
    id: "recalculate_by_rate",
    screen: "money",
    name: "Recalculate by rate",
    description:
      "Заполняет USD у платежей App Store по словарю курсов; без курса валюта остаётся вне выручки; уже посчитанные строки повторно не трогает.",
    risk: "danger",
    confirm: true,
  },
  {
    id: "daily_active_users",
    screen: "service",
    name: "Daily active users",
    description: "Значение за последний день периода.",
  },
  {
    id: "weekly_and_monthly_active_users",
    screen: "service",
    name: "Weekly and monthly active users",
    description: "Скользящие 7 и 30 дней.",
  },
  {
    id: "generations_saved",
    screen: "service",
    name: "Generations saved",
    description: "Показатель экономии генераций; формула в А не описана.",
  },
  {
    id: "top_features",
    screen: "service",
    name: "Top features",
    description: "Считает не то: колонка «Уникальные пользователи» не соответствует названию.",
  },
  {
    id: "events_per_day",
    screen: "service",
    name: "Events per day",
    description: "События по дням; без номера в А.",
  },
  {
    id: "funnel_3_steps",
    screen: "service",
    name: "Funnel (3 steps)",
    description:
      "Три шага по ключам вида onboarding:screen_view; заканчивается платежом, шага пейвола нет.",
  },
  {
    id: "link_to_payment",
    screen: "service",
    name: "Link to payment",
    description: "Считает не то: платящий здесь значит «когда-либо платил».",
  },
  {
    id: "onboarding_steps",
    screen: "service",
    name: "Onboarding steps",
    description: "Воронка онбординга по 6 шагам.",
  },
  {
    id: "consent_and_decline_rate",
    screen: "service",
    name: "Consent and decline rate",
    description: "Согласие и доля отказов к показам.",
  },
  {
    id: "retention",
    screen: "service",
    name: "Retention",
    description: "Считает не то: когорта это первая неделя в окне, а не неделя регистрации.",
  },
  {
    id: "day_1_day_7_return_by_start_platform",
    screen: "service",
    name: "Day 1 / Day 7 return by start platform",
    description: "Возврат на 1-й и 7-й день по платформе первого входа.",
  },
  {
    id: "web_save_access_funnel",
    screen: "service",
    name: "Web: save-access funnel",
    description: "Воронка предложения «сохрани доступ» на вебе.",
  },
  {
    id: "pair_readings_sections_taps_on_locked_lens",
    screen: "service",
    name: "Pair readings sections; taps on locked Lens",
    description:
      "Какие разделы парных разборов смотрят и сколько раз нажимают на закрытую линзу (Lens).",
  },
  {
    id: "pair_day_loop",
    screen: "service",
    name: "Pair day loop",
    description: "Панель про Pair day; своё окно, не слушается переключателя периода.",
  },
  {
    id: "lens_funnel",
    screen: "service",
    name: "Lens funnel",
    description: "Считает не то в части «Купили уровень» (название и формула расходятся).",
  },
  {
    id: "likes_by_relation_level",
    screen: "service",
    name: "Likes by Relation level",
    description: "Лайки с разбивкой по типу отношений; «Покупки / тап по замку» считает не то.",
  },
  {
    id: "reading_variety",
    screen: "service",
    name: "Reading variety",
    description: "Панель про повторяемость текстов.",
  },
  {
    id: "paid_text_style_rule_violations",
    screen: "service",
    name: "Paid text: style rule violations",
    description: "Нарушения правил стиля платных текстов (питается настройками Style check).",
  },
  {
    id: "text_forms",
    screen: "forms",
    name: "Text forms",
    description: "Аналитика режима готовых форм.",
  },
  {
    id: "second_synastry",
    screen: "service",
    name: "Second Synastry",
    description: "Повторные синастрии; свои окна, не слушается переключателя периода.",
  },
  {
    id: "background_jobs",
    screen: "service",
    name: "Background jobs",
    description: "Не про использование, лежит на этой странице.",
  },
  {
    id: "stars_products_telegram_table",
    screen: "money",
    name: "Stars products (Telegram) table",
    description:
      "Код, цена в Stars, состав выдаваемого (сырой JSON, «Grants»), активность, порядок; цену iOS здесь не задают.",
  },
  {
    id: "product_price_stars",
    screen: "money",
    name: "Product price (Stars)",
    description: "Меняет счёт Stars; уже купленное не затрагивается; пишется в аудит.",
    risk: "danger",
    confirm: true,
  },
  {
    id: "product_active",
    screen: "money",
    name: "Product active",
    description: "Скрывает товар с пейволла одним кликом.",
    risk: "danger",
    confirm: true,
  },
  {
    id: "create_product",
    screen: "money",
    name: "Create product",
    description: "Код, цена, состав в JSON; пишется в аудит.",
    risk: "caution",
    confirm: true,
  },
  {
    id: "free_tier",
    screen: "money",
    name: "Free tier",
    description: "Натал, дней триала транзитов, дневной транзит бесплатно; подробно в В.2.",
    risk: "danger",
    confirm: true,
  },
  {
    id: "user_search",
    screen: "people",
    name: "User search",
    description: "Поиск по username, tg_id, id, device_id, apple_sub.",
  },
  {
    id: "top_users_by_payments",
    screen: "people",
    name: "Top users by payments",
    description: "Считает не то: Stars без USD дают 0.",
  },
  {
    id: "top_users_by_credits",
    screen: "people",
    name: "Top users by credits",
    description: "Считает не то: только синастрия плюс композит.",
  },
  {
    id: "balances",
    screen: "people",
    name: "Balances",
    description:
      "Синастрия, Composite, relation named/words, Транзиты до, Legacy credits, Стоимость LLM; английские имена счётчиков.",
  },
  {
    id: "credit_history",
    screen: "people",
    name: "Credit history",
    description: "Последние 50 записей.",
  },
  {
    id: "grant_credits",
    screen: "people",
    name: "Grant credits",
    description:
      "Любое положительное число без потолка; списать назад из админки нельзя; пишется в аудит.",
    risk: "danger",
    confirm: true,
  },
  {
    id: "refund_stars",
    screen: "people",
    name: "Refund Stars",
    description:
      "Реальные деньги Telegram и откат начисленного; только Stars, App Store не возвращается.",
    risk: "danger",
    confirm: true,
  },
  {
    id: "admin_rights",
    screen: "people",
    name: "Admin rights",
    description: "Дают доступ ко всем действиям в этом списке; себе менять нельзя; обратимо.",
    risk: "danger",
    confirm: true,
  },
  {
    id: "regenerate_readings",
    screen: "people",
    name: "Regenerate readings",
    description:
      "Удаляет кэш чтений, ломает старые share-ссылки, тратит деньги на ИИ; что видит пользователь при сбое после удаления, [не знаю].",
    risk: "danger",
    confirm: true,
  },
  {
    id: "support_tickets_open",
    screen: "people",
    name: "Support tickets (open)",
    description: "Только открытые; отвеченных и закрытых на странице нет.",
  },
  {
    id: "support_reply",
    screen: "people",
    name: "Support reply",
    description:
      "Telegram-пользователь получает ответ; у iOS-пользователя без Telegram ответ не уходит, но тикет помечается «отвечен»; повторно ответить нельзя.",
    risk: "danger",
    confirm: true,
  },
  {
    id: "tuning_table_operation_by_model",
    screen: "texts-ai",
    name: "Tuning table (operation by model)",
    description: "Операция, модель, effort: 👍/👎 и отклик.",
  },
  {
    id: "generation_log",
    screen: "texts-ai",
    name: "Generation log",
    description:
      "Список с фильтрами; деталь открывает полный текст пользователя и промпты (персональные данные), открытие пишется в аудит.",
  },
  {
    id: "audit_log",
    screen: "service",
    name: "Audit log",
    description:
      "Последние 200 действий админов; фильтры по действию и tg_id; payload в сыром JSON.",
  },
] as const satisfies readonly PanelEntry[];
